export const wait = async delay => {
  let promise = new Promise((resolve/*, reject*/) => {
    setTimeout(() => resolve(), delay)
  });

  await promise;
}
